import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import {
  AlertService,
  MessageSeverity,
} from 'src/app/shared/services/alert.service';
import { RoleService } from 'src/app/services/role/role.service';
import { AdminService } from 'src/app/services/admin/admin.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GetUserInfo } from 'src/app/models/admin/admin';
import { decryptData } from 'src/app/shared/helpers/decrypt';

@Component({
  selector: 'app-role-modal',
  templateUrl: './role-modal.component.html',
  styleUrls: ['./role-modal.component.css'],
})
export class RoleModalComponent implements OnInit {
  activeItem: any = null;
  roleForm: FormGroup;
  headquarterSelect: number;
  headquarters = [];
  edit = false;
  menu = [];
  parents = [
    { id: 2, name: 'Administracion' },
    { id: 11, name: 'Video Analítica' },
    { id: 16, name: 'IOT' },
    { id: 20, name: 'ShowRoom' },
    { id: 25, name: 'Streaming' },
  ];
  firstPage: string;
  userPermissionMaster: number;

  constructor(
    public dialogRef: MatDialogRef<RoleModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private roleService: RoleService,
    private adminService: AdminService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog
  ) {
    this.firstPage = localStorage.getItem(AppConstants.Session.FIRST_PAGE);
    this.userPermissionMaster = +decryptData(localStorage.getItem(AppConstants.Session.USER_MASTER_PERMISSION));
  }

  ngOnInit() {
    this.createForm();
    this.getListMenu();
    if (this.data.action == AppConstants.OperationType.UPDATE) {
      this.edit = true;
      this.roleForm.controls['name'].setValue(this.data.obj.name);
    }
  }

  createForm() {
    this.roleForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(50)]],
    });
  }

  get f() {
    return this.roleForm.controls;
  }

  save() {
    if (!this.activeItem) {
      this.alertService.showMessage(
        'Error al guardar',
        'Por favor, selecciona un item antes de guardar.',
        MessageSeverity.error
      );
      return;
    }
    if (this.roleForm.valid) {
      const payload = {
        name: this.roleForm.value['name'],
        menu: JSON.stringify(this.menu),
        id:
          this.data.action == AppConstants.OperationType.UPDATE
            ? this.data.obj.id
            : 0,
        idEnterprise: this.data.idEnterprise,
        idUser: localStorage.getItem(AppConstants.Session.USERID),
        redirect: '/home/' + this.activeItem,
      };
      // console.log(payload);
      this.spinner.show();
      if (this.data.action == AppConstants.OperationType.ADD) {
        this.roleService.create(payload).subscribe((_) => {
          if (!_.message) {
            this.alertService.showMessage(
              AppConstants.TitleModal.CREATE_ROLE,
              AppConstants.MessageModal.CREATE,
              MessageSeverity.success
            );
            this.spinner.hide();
            this.data.result = true;
            this.dialogRef.close(this.data);
          } else {
            this.alertService.showMessage(_.message, '', MessageSeverity.error);
            this.spinner.hide();
          }
        });
      } else {
        this.roleService.update(payload).subscribe((_) => {
          if (!_.message) {
            this.alertService.showMessage(
              AppConstants.TitleModal.UPDATE_ROLE,
              AppConstants.MessageModal.UPDATE,
              MessageSeverity.success
            );
            this.adminService
              .getUserInfoByUsername(
                localStorage.getItem(AppConstants.Session.USERNAME)
              )
              .subscribe(
                (response: GetUserInfo) => {
                  console.log(response);
                  if (response.error == null) {
                    var enterprise = response.data;
                    localStorage.setItem(
                      AppConstants.Session.USERID,
                      enterprise.userId.toString()
                    );
                    localStorage.setItem(
                      AppConstants.Session.USER,
                      enterprise.fullName.toString()
                    );
                    localStorage.setItem(
                      AppConstants.Session.USER,
                      enterprise.fullName.toString()
                    );
                    localStorage.setItem(
                      AppConstants.Session.ENTERPRISES,
                      JSON.stringify(enterprise.enterprises)
                    );
                    localStorage.setItem(
                      AppConstants.Session.HEADQUARTERS,
                      JSON.stringify(enterprise.headquarters)
                    );
                    if (enterprise.enterprises.length > 0) {
                      localStorage.setItem(
                        AppConstants.Session.ENTERPRISE,
                        enterprise.enterprises[0]['id'].toString()
                      );
                      localStorage.setItem(
                        AppConstants.Session.HEADQUARTER,
                        '0'
                      );
                    }
                    localStorage.setItem(
                      AppConstants.Session.ENTERPRISE_SYSTEM,
                      enterprise.systems.toString()
                    );
                    localStorage.setItem(AppConstants.Session.MENU_ICON, '0');
                    localStorage.setItem(
                      AppConstants.Session.CHANGE_ENTERPRISE_MENU,
                      '0'
                    );
                    localStorage.setItem(
                      AppConstants.Session.LOGO,
                      enterprise.enterprises[0]['logo'].toString()
                    );
                    localStorage.setItem(
                      AppConstants.Session.THEME_COLOR1,
                      enterprise.enterprises[0]['themeColor1'].toString()
                    );
                    localStorage.setItem(
                      AppConstants.Session.THEME_COLOR2,
                      enterprise.enterprises[0]['themeColor2'].toString()
                    );
                    var idUser = parseInt(
                      localStorage.getItem(AppConstants.Session.USERID)
                    );
                    this.adminService
                      .getMenuEnterpriseRole(
                        parseInt(enterprise.enterprises[0]['id']),
                        parseInt(
                          localStorage.getItem(AppConstants.Session.HEADQUARTER)
                        ),
                        idUser
                      )
                      .subscribe((response) => {
                        var menu = response.data;
                        localStorage.setItem(
                          AppConstants.Session.MENU,
                          JSON.stringify(menu)
                        );
                        window.location.reload();
                      });
                  }
                  this.spinner.hide();
                },
                (error: HttpErrorResponse) => {
                  this.spinner.hide();
                }
              );
            this.data.result = true;
            this.dialogRef.close(this.data);
          } else {
            this.alertService.showMessage(_.message, '', MessageSeverity.error);
            this.spinner.hide();
          }
        });
      }
    } else {
      this.roleForm.markAllAsTouched();
    }
  }

  getListMenu() {
    this.spinner.show();
    this.activeItem = this.data.obj.redirect;
    this.adminService.getMenuEnterprise(this.data.idEnterprise).subscribe(
      (_) => {
        var _this = this;
        if (AppConstants.OperationType.UPDATE == this.data.action) {
          var json = JSON.parse(_this.data.obj.menu);
          console.log('json', json);
          if (json) {
            _.data.forEach((x) => {
              json.forEach((y) => {
                if (x.id == y.id) {
                  x.activeWrite = y.activeWrite;
                  x.activeRead = y.activeRead;
                  if (!x.activeRead && !x.activeWrite) {
                    x.activeWrite = 0;
                    x.activeRead = 0;
                  }
                  if (_this.activeItem == '/home/' + y.tag) {
                    _this.activeItem = y.tag;
                  }
                }
              });
            });

            this.menu = _.data;
          }
        } else {
          var array = [];
          _this.parents.forEach((x) => {
            _.data.forEach((y) => {
              if (y.id == x.id || y.idParent == x.id) {
                array.push(y);
              }
            });
          });
          this.menu = array;
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      }
    );
  }

  showCheckbox(item: any) {
    if (!item.isChild) {
      if (this.menu.filter((x) => x.idParent == item.id).length > 0) {
        return false;
      } else {
        return true;
      }
    }
    return true;
  }

  close() {
    this.dialog.closeAll();
  }

  activeRead(item: any) {
    item.activeRead =
      item.activeRead == 1 ? (item.activeRead = 0) : (item.activeRead = 1);

    if (item.activeRead) {
      item.activeWrite = 0;
      item.activeNone = false;
    }
  }

  activeWrite(item: any) {
    item.activeWrite =
      item.activeWrite == 1 ? (item.activeWrite = 0) : (item.activeWrite = 1);

    if (item.activeWrite) {
      item.activeRead = 0;
      item.activeNone = false;
    }
  }

  toggleNone(item: any) {
    item.activeNone = !item.activeNone;

    if (item.activeNone) {
      item.activeRead = 0;
      item.activeWrite = 0;
    }
  }

  mainRoute(tag: string) {
    this.activeItem = tag;
  }
}
